module.exports = __webpack_public_path__ + "static/media/dinova_logo.57c29883.png";